<template>
  <div class="mit-home-page mit-page">
      <v-container>
      <v-row>
        <v-col cols="12" class="d-flex justify-left">
          <div class="pa-2">
            <h3 class="pb-2">TIG Storage</h3>
            <p>CSAIL storage information.</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

  export default {
    name: 'MitHomePage',
    components: {
    },
    data: function() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      // exampleFunction: function(model) {
      //   console.log(model);
      // }
    }
  }
</script>

<style lang="scss" scoped>

</style>
